module.exports = __webpack_public_path__ + "img/logo.20ee269.svg";